import { observer } from 'mobx-react-lite'
import React from 'react'
import { View } from 'react-native'
import { styles } from './InfoItemStyle'
import { DS } from '@/design-system'

export interface InformationGameOverProps {
  text: string
  value: string
  highlight?: boolean
}

export const InfoItem = observer(({ text, value, highlight }: InformationGameOverProps) => {
  return (
    <View style={styles.information}>
      <DS.Text variant="Mini/Bold" color="Global/White" style={{ textTransform: 'uppercase' }}>
        {text}
      </DS.Text>

      <View style={highlight ? styles.highlight : {}}>
        <DS.Text
          variant={highlight ? 'Mini/Bold' : 'Body Small/Medium'}
          color={highlight ? 'Global/Black' : 'Global/White'}
        >
          {value}
        </DS.Text>
      </View>
    </View>
  )
})
